export default __webpack_public_path__ + "static/media/iphone_mockup.9af086bb.svg";